import { graphql } from "@/lib/gql/__generated__";

export const SEND_SAMPLE_EMAIL_REQUEST_RESERVATION_REQUESTED_MUTATION = graphql(`
	mutation TestEmailRequestReservationAtRequest($input: TestEmailInput!) {
		testEmailRequestReservationAtRequest(input: $input) {
			userErrors
			status
		}
	}
`);
